export const NEW_CONSOLE_OUTPUT = 'NEW_CONSOLE_OUTPUT';
export const SET_CONSOLE_OUTPUT = 'SET_CONSOLE_OUTPUT';
export const SET_ALERT = 'SET_ALERT';
export const SET_NOTIFICATION = 'SET_NOTIFICATION';
export const BACKEND_VERSION = 'BACKEND_VERSION';
export const SET_COLOR = 'SET_COLOR';
export const CONFIG_VARS = 'CONFIG_VARS';
